import { Construction } from "lucide-react";
import { getSectionConfig, type AdminSection } from "../../../../shared/index";

/**
 * Generic placeholder for sections we haven't ported yet. The old Next.js
 * admin had the real implementation; we're keeping the navigation entries
 * so admins with those permissions still see the section in the sidebar.
 */
export function PlaceholderPage({ section }: { section: AdminSection }) {
  const config = getSectionConfig(section);
  return (
    <div className="rounded-lg border bg-card p-12 text-center">
      <Construction className="mx-auto mb-4 h-10 w-10 text-muted-foreground" />
      <h1 className="text-xl font-semibold">{config?.label ?? section}</h1>
      <p className="mt-2 text-sm text-muted-foreground">
        This section hasn't been ported to the new admin yet.
      </p>
      <p className="mt-1 text-xs text-muted-foreground">
        For now, use the legacy admin to manage {config?.label.toLowerCase() ?? section}.
      </p>
    </div>
  );
}
